import type { companies as en } from '@/i18n/locales/en/companies';
import type { Translation } from '@/i18n/types';

export const companies: Translation<typeof en> = {
  list: {
    title: 'Empresas',
    newCompany: 'Nova empresa',
    empty: 'Nenhuma empresa visível para ti.',
    name: 'Nome',
    created: 'Criada',
    rowsLabel: 'as empresas',
    healthTitle: 'Saúde da organização',
    healthCompanies: 'Empresas',
    healthEditions: 'Edições',
    healthPilots: 'Pilotos',
    healthPilotsLabel: 'o resumo dos pilotos',
    healthActivePilotCount: '{{count}} empresas com um piloto ativo',
  },
  detail: {
    thisCompany: 'empresa',
    rename: 'Mudar nome',
    companyAdmins: 'Administradores da empresa',
    delete: 'Eliminar',
    departmentsTitle: 'Departamentos',
    newDepartment: 'Novo departamento',
    departmentsEmpty: 'Ainda sem departamentos.',
    departmentsLabel: 'os departamentos',
    name: 'Nome',
    statistics: 'Estatísticas',
    collectiveConsent: 'Consentimento coletivo',
    inForce: 'em vigor',
    settingsTitle: 'Definições',
    settingsLabel: 'as definições',
    change: 'Alterar',
    minGroupSizeLabel: 'Tamanho mínimo do grupo para agregados:',
    systemDefault: 'predefinição do sistema',
    companyOverride: 'substituição da empresa',
    domainsTitle: 'Domínios de e-mail',
    domainsLabel: 'os domínios',
    manage: 'Gerir',
    domainsEmpty: 'Nenhum domínio registado.',
    membersTitle: 'Membros',
    membersLabel: 'os membros',
    addPerson: 'Adicionar pessoa',
    membersEmpty: 'Sem membros.',
    email: 'E-mail',
    login: 'Acesso',
    source: 'Origem',
    actions: 'Ações',
    yes: 'sim',
    no: 'não',
  },
  form: {
    newTitle: 'Nova empresa',
    name: 'Nome',
    cancel: 'Cancelar',
    create: 'Criar empresa',
    editTitle: 'Mudar o nome da empresa',
    save: 'Guardar',
    deleteTitle: 'Eliminar empresa',
    deleteLead:
      'Eliminar {{name}} também termina os seus domínios e linhas de pertença. Isto não pode ser desfeito. Escreve o nome da empresa para confirmar.',
    companyNameLabel: 'Nome da empresa',
    deletePermanently: 'Eliminar definitivamente',
    settingsTitle: 'Limite de agregação',
    settingsLead:
      'O tamanho mínimo do grupo abaixo do qual os agregados não são mostrados. Deixa em branco para voltar à predefinição do sistema. A API impõe um limite mínimo absoluto.',
    minGroupSize: 'Tamanho mínimo do grupo',
    domainsTitle: 'Domínios de e-mail',
    domainsLead:
      'Um endereço verificado num destes domínios inscreve o seu titular nesta empresa ao iniciar sessão. As pertenças existentes mantêm-se quando um domínio é removido.',
    remove: 'Remover',
    addDomain: 'Adicionar domínio',
    add: 'Adicionar',
    backToCompany: 'Voltar à empresa',
  },
  health: {
    title: 'Saúde da organização',
    edition: 'Edição',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Membros',
    pilotsTitle: 'Pilotos',
    pilotsLabel: 'o estado dos pilotos',
    noPilots: 'Ainda não há pilotos.',
    activeCount: '{{count}} ativos',
    scaledCount: '{{count}} escalados',
    totalCount: '{{count}} no total',
    viewAllPilots: 'Ver todos os pilotos',
  },
};
